import { render, staticRenderFns } from "./autocorre.vue?vue&type=template&id=5b72ac10&"
import script from "./autocorre.vue?vue&type=script&lang=js&"
export * from "./autocorre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports